import React from 'react';
import { motion } from 'framer-motion';
import { drawRule, fadeUp, stagger, viewport } from './motion';

// Every section opens the same way: optional eyebrow, title, a rule that draws
// itself, then the standfirst. Keeping it in one place is what makes the
// section rhythm read as deliberate rather than repeated.
function SectionHeading({ eyebrow, title, children, className = '' }) {
  return (
    <motion.div
      className={`text-center ${className}`}
      variants={stagger(0.12)}
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
    >
      {eyebrow && (
        <motion.p
          variants={fadeUp}
          className="mb-3 text-[11px] tracking-wide text-slate-500"
        >
          {eyebrow}
        </motion.p>
      )}

      <motion.h2
        variants={fadeUp}
        className="text-3xl font-bold tracking-tight text-gray-800 md:text-4xl"
      >
        {title}
      </motion.h2>

      <motion.div
        variants={drawRule}
        style={{ transformOrigin: 'center' }}
        className="mx-auto mt-4 h-1 w-20 rounded-full bg-gradient-to-r from-blue-600 to-indigo-700"
      />

      {children && (
        <motion.p
          variants={fadeUp}
          className="mx-auto mt-6 max-w-3xl text-lg text-gray-600 md:text-xl"
        >
          {children}
        </motion.p>
      )}
    </motion.div>
  );
}

export default SectionHeading;
